// G+J generic scroll-snap carousel: arrows step one page, dots show/jump to pages.
// Markup: <gj-carousel> with [data-carousel-track], [data-carousel-prev], [data-carousel-next],
// [data-carousel-dots], [data-carousel-controls].
if (!customElements.get('gj-carousel')) {
  customElements.define(
    'gj-carousel',
    class GjCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        this.prev = this.querySelector('[data-carousel-prev]');
        this.next = this.querySelector('[data-carousel-next]');
        this.dots = this.querySelector('[data-carousel-dots]');
        this.controls = this.querySelector('[data-carousel-controls]');
        if (!this.track) return;

        this.prev?.addEventListener('click', () => this.go(this.page - 1));
        this.next?.addEventListener('click', () => this.go(this.page + 1));
        this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });
        this.resizeObserver = new ResizeObserver(() => this.build());
        this.resizeObserver.observe(this.track);
        this.build();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      get items() {
        return Array.from(this.track.children);
      }

      // Number of whole cards visible at once.
      get perView() {
        const first = this.items[0];
        if (!first) return 1;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return Math.max(1, Math.floor((this.track.clientWidth + gap + 1) / (first.offsetWidth + gap)));
      }

      get pageCount() {
        return Math.max(1, Math.ceil(this.items.length / this.perView));
      }

      build() {
        const count = this.pageCount;
        if (this.controls) this.controls.hidden = this.track.scrollWidth <= this.track.clientWidth + 2;
        if (this.dots && this.dots.childElementCount !== count) {
          this.dots.innerHTML = Array.from(
            { length: count },
            (_, i) => `<button type="button" aria-label="Go to page ${i + 1} of ${count}"></button>`
          ).join('');
          Array.from(this.dots.children).forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));
        }
        this.onScroll();
      }

      go(page) {
        const target = Math.max(0, Math.min(this.pageCount - 1, page));
        const item = this.items[target * this.perView];
        if (!item) return;
        const left = item.offsetLeft - this.track.offsetLeft - parseFloat(getComputedStyle(this.track).paddingLeft || 0);
        this.track.scrollTo({ left: Math.min(left, this.track.scrollWidth - this.track.clientWidth), behavior: 'smooth' });
      }

      onScroll() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const atEnd = this.track.scrollLeft >= max - 2;
        const step = (this.items[0]?.offsetWidth || 1) + (parseFloat(getComputedStyle(this.track).columnGap) || 0);
        this.page = atEnd ? this.pageCount - 1 : Math.round(this.track.scrollLeft / (step * this.perView));
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = atEnd;
        Array.from(this.dots?.children || []).forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.page)));
      }
    }
  );
}
